import dayjs from "dayjs";

export default (time: number): string => {
    return dayjs().startOf("day").add(time, "hour").format("HH:mm");
};